/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_Submit_DescInputs */

const en_directory_nav_submit_desc = /** @type {(inputs: Directory_Nav_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an AI tool, AIGC product, or service to the directory.`)
};

const zh_directory_nav_submit_desc = /** @type {(inputs: Directory_Nav_Submit_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加 AI 工具、AIGC 产品或服务到导航站。`)
};

/**
* | output |
* | --- |
* | "Add an AI tool, AIGC product, or service to the directory." |
*
* @param {Directory_Nav_Submit_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_submit_desc = /** @type {((inputs?: Directory_Nav_Submit_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_Submit_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_submit_desc(inputs)
	return zh_directory_nav_submit_desc(inputs)
});
export { directory_nav_submit_desc as "directory.nav.submit_desc" }